import { render, staticRenderFns } from "./SystemStatisticsPayOrder.vue?vue&type=template&id=8bea120e&"
import script from "./SystemStatisticsPayOrder.vue?vue&type=script&lang=ts&"
export * from "./SystemStatisticsPayOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SystemStatisticsPayOrder.vue"
export default component.exports